import { Component, ComponentRef, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { GooglePlacesService } from '../../../domain/service/GooglePlaceService';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { NotificationType } from '../../../domain/model/enums/notificationType';
import { PropertyService } from '../../../domain/service/propertyService';
import { ProfileService } from '../../../domain/service/profileService';
import { CommonServices } from '../../../domain/service/commonService';
import { OwnerAccount } from '../../../domain/model/profile/indiviualPropertyOwnerProfie';
import { Dialog } from '@angular/cdk/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { HttpResponseDto } from '../../../domain/model/common/httpResponseDto';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationComponent } from '../../../shared/notification/notification.component';

@Component({
  selector: 'app-indiviual-property-owner',
  templateUrl: './indiviual-property-owner.component.html',
  styleUrl: './indiviual-property-owner.component.css'
})
export class IndiviualPropertyOwnerComponent implements OnInit , OnChanges{
  externalUser!: ExternalUser | null;
  @Input() ownerAccount!: OwnerAccount;    
  dialog = inject(Dialog);
  ownerForm  !: FormGroup; 
    private overlayRef!: OverlayRef;
  constructor(private overlay: Overlay,private fb: FormBuilder, private commonServices: CommonServices,private profileServices: ProfileService, private googlePlacesService: GooglePlacesService, private readonly auth: AuthenticationService) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm(this.ownerAccount);
  }

  private buildForm(data: OwnerAccount | undefined): void {
  
    this.ownerForm = this.fb.group({
      firstName: new FormControl(data?.firstName, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      lastName: new FormControl(data?.lastName, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      email: new FormControl(data?.email, [
        Validators.required,
        Validators.maxLength(320),
        Validators.email
      ]),
      phoneNumber: new FormControl(data?.phoneNumber, [
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
      ]),
      note: new FormControl(data?.note),
      ownerStreetAddress: new FormControl(data?.streetAddress, Validators.required),
      aptUnitSuite: new FormControl(data?.aptUnitSuite),
      city: new FormControl(data?.city, Validators.required),
      state: new FormControl(data?.stateId, [Validators.required, Validators.min(0)]),
      zipCode: new FormControl(data?.zipCode, [
        Validators.required,
        Validators.maxLength(12),
        Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
      ]),
      addressName: new FormControl(data?.internationalAddressName),
      addressOrPoBox: new FormControl(data?.internationalPoboxNumber),
      cityStateProvince: new FormControl(data?.internationalCityStateProvince),
      country: new FormControl(data?.countryId),
      printedName: new FormControl({value: data?.account.printedName, disabled: true} ),
    })
  }
  ngOnInit(): void {
    this.commonServices.getAllCountry()
    .subscribe(data => {
      this.country = data.sort((a, b) => a.name.localeCompare(b.name));;
    });


  this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data.sort((a, b) => a.name.localeCompare(b.name));
    });
    this.externalUser = this.auth.getCurrentUser2();
 
  
  }
  suggestions: any[] = [];
  addressType: string = '1';
  states: DropDownModel[] = [];
  country: DropDownModel[] = [];
 
  radioChangeAddress(event: any) {
    this.addressType = event.value;
    if (event.value == "1") {
      this.ownerForm.get('addressName')?.clearValidators();
      this.ownerForm.get('addressName')?.updateValueAndValidity();

      this.ownerForm.get('addressOrPoBox')?.clearValidators();
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();

      this.ownerForm.get('cityStateProvince')?.clearValidators();
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();

      this.ownerForm.get('country')?.clearValidators();
      this.ownerForm.get('country')?.updateValueAndValidity();

      this.ownerForm.get('ownerStreetAddress')?.addValidators(Validators.required);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();



      this.ownerForm.get('city')?.addValidators(Validators.required);
      this.ownerForm.get('city')?.updateValueAndValidity();

      this.ownerForm.get('state')?.addValidators(Validators.required);
      this.ownerForm.get('state')?.updateValueAndValidity();

      this.ownerForm.get('zipCode')?.addValidators(Validators.required);
      this.ownerForm.get('zipCode')?.addValidators(Validators.maxLength(12));
      this.ownerForm.get('zipCode')?.addValidators(Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/));
      this.ownerForm.get('zipCode')?.updateValueAndValidity();

    }
    if (event.value == "2") {

      this.ownerForm.get('addressName')?.addValidators(Validators.required);
      this.ownerForm.get('addressName')?.updateValueAndValidity();

      this.ownerForm.get('addressOrPoBox')?.addValidators(Validators.required);
      this.ownerForm.get('addressOrPoBox')?.updateValueAndValidity();

      this.ownerForm.get('cityStateProvince')?.addValidators(Validators.required);
      this.ownerForm.get('cityStateProvince')?.updateValueAndValidity();

      this.ownerForm.get('country')?.addValidators(Validators.required);
      this.ownerForm.get('country')?.updateValueAndValidity();


      this.ownerForm.get('ownerStreetAddress')?.clearValidators();
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();

      this.ownerForm.get('aptUnitSuite')?.clearValidators();
      this.ownerForm.get('aptUnitSuite')?.updateValueAndValidity();

      this.ownerForm.get('city')?.clearValidators();
      this.ownerForm.get('city')?.updateValueAndValidity();

      this.ownerForm.get('state')?.clearValidators();
      this.ownerForm.get('state')?.updateValueAndValidity();

      this.ownerForm.get('zipCode')?.clearValidators();
      this.ownerForm.get('zipCode')?.updateValueAndValidity();
    }


  }
  async selectPlace(place: any) {


    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);
    if (selectedZipCode.zip) {
      this.ownerForm.get('zipCode')?.setValue(selectedZipCode.zip);
    }

    if (selectedZipCode.city) {
      this.ownerForm.get('city')?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find(e => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      this.ownerForm.get('state')?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.ownerForm.get('ownerStreetAddress')?.setValue(selectedZipCode.address);
      this.ownerForm.get('ownerStreetAddress')?.updateValueAndValidity();
      this.ownerForm.get('ownerStreetAddress')?.markAsUntouched();
    }
  }
    showNotification(message: string, title: string, notificationType: NotificationType): void {
        // Create the overlay (top-right) — previously overlayRef was never instantiated,
        // so attaching threw and no notification ever appeared.
        this.overlayRef = this.overlay.create({
          positionStrategy: this.overlay.position().global().top('24px').right('24px'),
          hasBackdrop: false,
        });
        // Create a Portal instance of our `NotificationComponent`
        const notificationPortal = new ComponentPortal(NotificationComponent);
        // Attach our `NotificationComponent` to the Overlay Portal
        const notificationRef: ComponentRef<NotificationComponent> = this.overlayRef.attach(notificationPortal);
        // Now we can access the component instance
        // and we can pass input for the `message` prop we created.
        notificationRef.instance.message = message;
        notificationRef.instance.title = title;
        notificationRef.instance.type = notificationType;
        notificationRef.instance.overlayRef = this.overlayRef;
        notificationRef.instance.getColor();
    
        // Set a timeout to detach our component from the overlay
        // after 3000 milliseconds
        setTimeout(() => {
          this.overlayRef.detach();
        }, 10000);
      }
    showChangePasswod(){
           const dialogRef = this.dialog.open<HttpResponseDto>(ChangePasswordComponent, {
                width: "500px",
                height: "510px",
                disableClose: true, 
              });
               dialogRef.closed.subscribe((result) => {
                    console.log("The dialog was closed");
              
                    if (result) { 
                      if (result?.error === true){
                        //    this.showNotification(
                        //   "Current password is invalid .",
                        //   "Change Password",
                        //   NotificationType.Error
                        // );
                        }else {
                          // this.showNotification(
                          //   "Password successfully changed.",
                          //   "Change Password",
                          //   NotificationType.Success
                          // );
                        }
                    }
                  });
        }
        save(){
          if (this.ownerForm.invalid) {
            this.ownerForm.markAllAsTouched();
            this.showNotification(
              "Please complete the required fields before saving.",
              "Profile",
              NotificationType.Error
            );
            return;
          }
          const v = this.ownerForm.getRawValue();
          const model = {
            id: this.ownerAccount?.id,
            firstName: v.firstName,
            lastName: v.lastName,
            email: v.email,
            phoneNumber: v.phoneNumber,
            streetAddress: v.ownerStreetAddress,
            aptUnitSuite: v.aptUnitSuite,
            city: v.city,
            stateId: v.state ? Number(v.state) : null,
            zipCode: v.zipCode,
            internationalAddressName: v.addressName,
            internationalPoboxNumber: v.addressOrPoBox,
            internationalCityStateProvince: v.cityStateProvince,
            countryId: v.country ? Number(v.country) : null,
            note: v.note,
          };
          this.profileServices.updateIndividualPropertyOwner(model).subscribe({
            next: () => this.showNotification(
              "Property info successfully updated", "Profile", NotificationType.Success),
            error: () => this.showNotification(
              "Could not save your changes. Please try again.", "Profile", NotificationType.Error),
          });
         }
}
